import React, { useEffect, useState } from "react";
// import swal from "sweetalert";

import Footer from "../component/Footer";
import Header from "../component/Header";
import axios from "../utlilites/axios";
import "./Custom.css";
import DetailSearch from "../component/DetailSearch";
import { useNavigate } from "react-router-dom";



export const Home = () => {
  const navigate = new useNavigate();

  //useStates

  const [loaders, setLoaders] = useState(false);
  const [loader, setLoader] = useState(true);
  const [getproperty, setGetproperty] = useState();
  const [path, setPath] = useState();

  //useStates

  //All property API fetching

  const property = () => {
    setLoaders(true);

    var config = {
      method: "get",
      url: "https://flexrental.dev-um.xyz/api/listning",
      headers: {
        Accept: "application/json",
      },
    };

    axios(config)
      .then(function (response) {
        console.log(response, "checking");
        if (response.status) {
          setGetproperty(response.data.listnings);
          setPath(response.data.imagepath);
          setLoader(false);
          setLoaders(false);
        } else {
          setGetproperty(["no result found"])
        }
        // setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);

        console.log(error);
      });
  };

  useEffect(() => {
    setLoaders(true);
    property();
  }, []);


  return (
    <>
      {loaders ? <div className="loader"></div>
        :
        <>
          <Header />

          <section className="bg-holder bg-overlay-black-30 banner-1" >
            <div className="container">
              <div className="row">
                <div className="col-12 position-relative margin_top">
                  <h1 className="text-white text-center mb-5 font fw-bolder">
                    Short Term Rentals Across The Globe
                  </h1>

                  <section>
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          <DetailSearch classna="text-light" setApi={setGetproperty} />
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>

          <section className="home-pb bg-black">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="section-title text-center my-5">
                    <h2 className="text-white">Our Listings</h2>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* <Card /> */}
                {getproperty?.map((i) => {
                  return (
                    <div className="col-sm-6 col-md-3">
                      <div className="property-item">
                        <div onClick={() => navigate("/listingdetail/" + i.id)}>
                          <div className="property-image bg-overlay-gradient-04">
                            <img
                              className="object_fit_cover home_card_img"
                              src={`http://flexrental.dev-um.xyz/storage/${i.cover_photo}`}
                              alt="Not Found "
                              width={"100%"}
                              height={174.6}
                            />
                          </div>
                          <div className="property-details bg-dark text-light">
                            <div className="property-details-inner">
                              <h5 className="property-title text-light">
                                {i.property_type}
                              </h5>
                              <h5 className="property-title text-light">
                                {i.address}
                              </h5>
                              <h5 className="property-title text-light">
                                {i.kind_space}
                              </h5>


                              <span className="property-address">
                                ${i.rate_per_night} Per Night
                              </span>
                              <br />

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

            </div>
          </section>

          <Footer />
        </>
      }
    </>
  );
};

export default Home;
